const translation = {
  CONTACT_TITLE_H5: 'Get In Touch',
  CONTACT_TITLE_H2: 'Contact Me',
  CONTACT_SUBJECT: 'Subject',
  CONTACT_NAME: 'Full Name',
  CONTACT_EMAIL: 'Email',
  CONTACT_MESSAGE: 'Message',
  CONTACT_BTN: 'Send Message'
};

export default translation;
